// Cliente Supabase partilhado (frontend).
//
// Segurança: no browser só pode ser usada a chave PUBLICÁVEL (publishable/anon).
// A service_role key NUNCA pode aparecer no frontend. Toda a proteção de dados
// é garantida por Row Level Security (RLS) no Supabase.
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigMissing = !supabaseUrl || !supabaseAnonKey;

if (supabaseConfigMissing) {
  // eslint-disable-next-line no-console
  console.error(
    '[Supabase] Variáveis em falta. Defina REACT_APP_SUPABASE_URL e ' +
      'REACT_APP_SUPABASE_ANON_KEY em .env.local e reinicie npm start (CRA só lê .env no arranque).'
  );
}

// Evita página branca se o dev server arrancou antes do .env.local existir.
const clientUrl = supabaseUrl || 'https://placeholder.supabase.co';
const clientKey = supabaseAnonKey || 'missing-anon-key';

export const supabase = createClient(clientUrl, clientKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'sosvor-auth',
  },
});

export default supabase;
